import React, { useState } from "react";
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  sendEmailVerification,
  updateProfile,
  AuthError,
} from "firebase/auth";
import styles from "./LoginRegister.module.css";
import { app, auth } from "../lib/firebase";
import { useNavigate } from "react-router-dom";
import { addUserProfile } from "../lib/controller";
import {
  DocumentData,
  QueryDocumentSnapshot,
  collection,
  getDocs,
  getFirestore,
  query,
  where,
} from "firebase/firestore";

function myMenuFunction() {
  var i = document.getElementById("navMenu");
  if (i!.className === "nav-menu") {
    i!.className += " responsive";
  } else {
    i!.className = "nav-menu";
  }
}

function login() {
  let x = document.getElementById("login");
  let y = document.getElementById("register");
  if (x) x.style.left = "4px";
  if (y) y.style.right = "-520px";
}

function register() {
  let x = document.getElementById("login");
  let y = document.getElementById("register");
  if (x) x.style.left = "-510px";
  if (y) y.style.right = "5px";
}

function HandleForgotPassword() {
  let answer: string | null = prompt(
    "Enter an email address to receive the password reset link"
  );
  let email: string = answer as string;

  sendPasswordResetEmail(auth, email)
    .then(() => {
      alert(
        "Email sent...check your inbox or spam for password reset instructions"
      );
    })
    .catch((error) => {
      console.log(error);
    });
}
var bodyStylesLoginAbout = document.body.style;
bodyStylesLoginAbout.setProperty("--about-login-display", "none");

const handleLoginAboutClick = (event: React.MouseEvent<HTMLElement>) => {
  console.log("Clicked open!");
  bodyStylesLoginAbout.setProperty("--about-login-display", "block");
};
const handleLoginCloseAboutClick = (event: React.MouseEvent<HTMLElement>) => {
  console.log("Clicked close!");
  bodyStylesLoginAbout.setProperty("--about-login-display", "none");
};

function LoginRegister() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [verifyPassword, setVerifyPassword] = useState("");

  const [userEmail, setUserEmail] = useState("");
  //const [userUID, setUserUID] = useState("");
  var userUID = "";
  const [userAILink1, setUserAILink1] = useState("");
  const [userAILink2, setUserAILink2] = useState("");
  const [userAILink3, setUserAILink3] = useState("");
  const [userAILink4, setUserAILink4] = useState("");
  const [userAbout, setUserAbout] = useState("");
  const [userConnections, setUserConnections] = useState([]);
  const [userAITools, setUserAITools] = useState([]);
  const [userCountry, setUserCountry] = useState("");
  const [userFirstName, setUserFirstName] = useState("");
  const [userLastName, setUserLastName] = useState("");
  const [userPhotoName, setUserPhotoName] = useState("photoURL.png");
  const [userProfileName, setUserProfileName] = useState("");
  const [userProfileLink1, setUserProfileLink1] = useState("");
  const [userProfileLink2, setUserProfileLink2] = useState("");
  const [userProfileLink3, setUserProfileLink3] = useState("");
  const [userProfileLink4, setUserProfileLink4] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  var bodyStylesLoginError = document.body.style;
  bodyStylesLoginError.setProperty("--error-login-display", "none");

  const handleCloseErrorClick = (event: React.MouseEvent<HTMLElement>) => {
    console.log("Error closed!");
    bodyStylesLoginError.setProperty("--error-login-display", "none");
    setPassword("");
    setVerifyPassword("");
  };

  const loginUser = async (e: any) => {
    e.preventDefault();
    setIsLoading(true);

    console.log("auth = ", auth);
    console.log("email = ", email);
    console.log("password = ", password);
    await signInWithEmailAndPassword(auth, email, password)
      .then((useCredential) => {
        const user = auth.currentUser;
        if (!user.emailVerified) {
          alert(
            "You must verify your account before loging in. Please check your inbox or spam for link"
          );
          setIsLoading(false);
          navigate("/");
        }

        console.log("In LoginRegister and user = " + user);
        console.log("In LoginRegister and cred =" + useCredential);
        console.log("In LoginRegister and succesful login");

        var doc: QueryDocumentSnapshot<DocumentData, DocumentData>;
        var currentUserID = "";
        var currentUser = "";
        var profile: DocumentData;
        const db = getFirestore(app);
        console.log("In LoginRegister  #1");
        auth.onAuthStateChanged(async (user) => {
          //const userValue = await Promise.resolve(user);
          //Promise.reject(console.log("err"));
          console.log("In LoginRegister  #2");
          if (user) {
            //if (userValue) {
            const currentUser = user;
            const currentUserID = user?.uid;
            console.log("In LoginRegister #3");
            console.log(
              "In LoginRegister  Currently logged in user =",
              currentUser
            );
            console.log(
              "In LoginRegister Currently logged in user id =",
              currentUserID
            );
            const q = query(
              collection(db, "userProfiles"),
              where("userUID", "==", currentUserID)
            );
            console.log("In LoginRegister  #4");

            const querySnapshot = await getDocs(q);

            console.log("In LoginRegister  #5");

            //if (!querySnapshot) return <div>Loading...</div>;
            for (doc of querySnapshot.docs) {
              console.log("In LoginRegister #6");

              const profile = doc.data();

              console.log("In LoginRegister  and the following is the doc");
              console.log(doc.id, " => ", doc.data());
              console.log(
                "In LoginRegister  userProfileName = ",
                doc.data().userProfileName
              );
              console.log(
                "In LoginRegister using profile and user email = ",
                profile.userEmail
              );
              console.log(
                "In LoginRegister  using photo = ",
                profile.userPhotoName
              );
              //const photo = JSON.stringify(profile.userPhotoName);

              setIsLoading(false);

              localStorage.setItem("myPicture", profile.userPhotoName);
              localStorage.setItem("welcomeRefresh", "No");
              const photoURL = localStorage.getItem("myPicture");
              localStorage.setItem("userUID", currentUserID);
              localStorage.setItem("userName", doc.data().userProfileName);
              localStorage.setItem("userEmail", doc.data().userEmail);
              //console.log("userName = ", localStorage.getItem("userName"));
              //              console.log(
              //  "In LoginRegister and retrieved photoURL = ",
              //  photoURL
              //);

              //console.log(
              //  "In LoginRegister after q and user id = ",
              //  currentUserID
              //);
              //console.log(
              //  "In LoginRegister  before return and doc.data() = ",
              //  doc.data()
              //);
              if (localStorage.getItem("userUID") != "") {
                navigate("/WelcomePage");
              }
              //return doc.data();
              //return profile.userPhotoName;
            }
            //navigate("/WelcomePage");
          }
          //navigate("/WelcomePage");
        });
      })
      .catch((error: any) => {
        console.log("In LoginRegister and error = " + error);
        //bodyStylesLoginError.setProperty("--error-login-display", "block");
        setEmail("");
        setPassword("");
        setIsLoading(false);
        alert("Either your email or your password are incorrect...");
      });
  };

  const registerUser = async (e: any) => {
    e.preventDefault();
    if (password !== verifyPassword) {
      bodyStylesLoginError.setProperty("--error-login-display", "block");
      return;
    }
    setIsLoading(true);
    //var results:any;

    await createUserWithEmailAndPassword(auth, email, password)
      .then(async (useCredential) => {
        //setIsLoading(true);
        const results = useCredential.user;
        console.log("User Credetials" + useCredential);
        console.log("results" + results);
        console.log("succesful signup");

        await sendEmailVerification(results);

        await updateProfile(results, { displayName: userProfileName }).catch(
          (err) => console.log(" displayName err = ", err)
        );
      })
      .catch((error: any) => {
        alert("Password must be at least 6 charcters and strong...");
        console.log(error);
        bodyStylesLoginError.setProperty("--error-login-display", "block");
        //setIsLoading(true);
      });

    auth.onAuthStateChanged((user) => {
      console.log("verified = ", user.emailVerified);
      if (user) {
        //setUserEmail(email);
        userUID = user.uid;
        console.log("before add doc user.uid = " + user.uid);
        console.log("before add doc userUID = " + userUID);
        console.log("before add doc email = " + email);
        console.log("before add doc userEmail = " + userEmail);
        console.log("before add doc userProfileName = " + userProfileName);
        //const addNewUserProfile = (e: React.FormEvent<HTMLFormElement>) => {
        //  e.preventDefault();
        console.log("right before add profile call...");
        addUserProfile({
          userAILink1,
          userAILink2,
          userAILink3,
          userAILink4,
          userAbout,
          userConnections,
          userAITools,
          userCountry,
          userEmail,
          userFirstName,
          userLastName,
          userPhotoName,
          userProfileName,
          userProfileLink1,
          userProfileLink2,
          userProfileLink3,
          userProfileLink4,
          userUID,
        });
        //addNewUserProfile(e);
        console.log("right after add profile call...");
        setIsLoading(false);
        //navigate("/WelcomePage");
        alert(
          "You must now verify your account before loging in. Please check your inbox or spam for link"
        );
        setIsLoading(false);
        setPassword("");
        setEmail("");
        navigate("/");
      }
    });
  };
  //const isMobile = window.innerWidth <= 768;
  //const mobileStyles = isMobile ? { fontsize: "14px" } : { fontSize: "18px};" };
  if (isLoading) {
    return <p> Loading...</p>;
  }
  return (
    <div className={styles.body}>
      <div>
        <div className={styles.wrapper}>
          <nav className={styles.navMain}>
            <div className={styles.navLogo}>
              <p>footprints</p>
            </div>
            <div className={styles.navMenu} id="navMenu">
              <ul>
                <li>
                  <a onClick={handleLoginAboutClick} className={styles.link}>
                    About
                  </a>
                </li>
              </ul>
            </div>
            <div className={styles.navMenuBtn}>
              <i className={styles.bxMenu} onClick={myMenuFunction}></i>
            </div>
          </nav>
          <div className={styles.showAboutLogin}>
            <a id="NewAbout">
              <p>
                footprints - about us <br />
                <br />
                We are the researchers who care... <br />
                We care about sharing our knowledge, <br />
                our experience, and our data to enable <br />
                others to discover new knowledge and <br />
                leave their own footprints in the <br />
                sands of research.
              </p>
              <button
                className={styles.closeLoginAboutButton}
                onClick={handleLoginCloseAboutClick}
              >
                Close
              </button>
            </a>
          </div>
          <div className={styles.formBox} style={{ marginTop: -250 }}>
            <form
              className={styles.loginContainer}
              id="login"
              onSubmit={loginUser}
            >
              <div className={styles.top}>
                <span>
                  Don't have an account?{" "}
                  <a href="#" onClick={register} style={{ marginTop: 0 }}>
                    Sign Up
                  </a>
                </span>
                <header style={{ fontWeight: 700, color: "white", height: 60 }}>
                  Login
                </header>
              </div>
              <div className={styles.inputBox}>
                <input
                  type="email"
                  className={styles.inputField}
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <i className={styles.bxEnvelope}></i>
              </div>
              <br />
              <div className={styles.inputBox}>
                <input
                  type="password"
                  className={styles.inputField}
                  placeholder="Password"
                  value={password}
                  autoComplete="password"
                  onChange={(e) => setPassword(e.target.value)}
                />
                <i className={styles.bxLockAlt}></i>
              </div>
              <br />
              <div className={styles.inputBox}>
                <input
                  type="submit"
                  className={styles.submit}
                  value="Sign In"
                />
              </div>
              <div className={styles.twoCol}>
                <div className={styles.one}>
                  <input type="checkbox" id="loginCheck" />
                  <label htmlFor="loginCheck"> Remember Me</label>
                </div>
                <div className={styles.two}>
                  <label>
                    <a href="#" onClick={HandleForgotPassword}>
                      Forgot password?
                    </a>
                  </label>
                </div>
              </div>
              <h5
                style={{
                  marginLeft: 110,
                  color: "purple",
                  background: "white",
                  width: 210,
                }}
              >
                &nbsp;&nbsp;&nbsp;&nbsp;image curtesy of Gal Carmeli
              </h5>
            </form>
            <form
              className={styles.registerContainer}
              id="register"
              onSubmit={registerUser}
            >
              <div className={styles.top} style={{ marginTop: 100 }}>
                <span>
                  Have an account?
                  <a href="#" onClick={login} style={{ marginTop: 0 }}>
                    Login
                  </a>
                </span>
                <header
                  style={{
                    fontWeight: 700,
                    color: "white",
                    height: 60,
                  }}
                >
                  Sign Up
                </header>
              </div>

              <div className={styles.inputBox}>
                <input
                  type="text"
                  className={styles.inputField}
                  placeholder="Profile name"
                  required
                  onChange={(e) => {
                    setUserProfileName(e.target.value);
                    localStorage.setItem("userProfileName", e.target.value);
                  }}
                />
                <i className={styles.bxUser}></i>
              </div>

              <br />
              <div className={styles.inputBox}>
                <input
                  type="email"
                  className={styles.inputField}
                  placeholder="Email"
                  required
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setUserEmail(e.target.value);
                  }}
                />
                <i className={styles.bxEnvelope}></i>
              </div>
              <br />
              <div className={styles.inputBox}>
                <input
                  type="password"
                  className={styles.inputField}
                  placeholder="Password"
                  value={password}
                  required
                  autoComplete="password"
                  onChange={(e) => setPassword(e.target.value)}
                />
                <i className={styles.bxLockAlt}></i>
              </div>
              <br />
              <div className={styles.inputBox}>
                <input
                  type="password"
                  className={styles.inputField}
                  placeholder="Verify Password"
                  autoComplete="password"
                  onChange={(e) => setVerifyPassword(e.target.value)}
                />
                <i className={styles.bxLockAlt}></i>
              </div>
              <br />
              <div className={styles.inputBox}>
                <input
                  type="submit"
                  className={styles.submit}
                  value="Register"
                />
              </div>
              <br />
              <div className={styles.twoCol}>
                <div className={styles.one}>
                  <input type="checkbox" id="registerCheck" />
                  <label htmlFor="registerCheck"> Remember Me</label>
                </div>
                <div className={styles.two}>
                  <label>
                    <a href="#">Terms & conditions</a>
                  </label>
                </div>
              </div>
              <h5
                style={{
                  marginLeft: 110,
                  color: "purple",
                  background: "white",
                  width: 210,
                }}
              >
                &nbsp;&nbsp;&nbsp;&nbsp;image curtesy of Gal Carmeli
              </h5>
            </form>
          </div>
          <div className={styles.showLoginError}>
            <a id="LoginError">
              <p>
                Invalid email or password <br />
              </p>
              <button
                className={styles.closeLoginErrorButton}
                onClick={handleCloseErrorClick}
              >
                Close
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginRegister;
